<template>
  <div class="second-layout">
    <highlight-container title="Nossa história" even class="pa-0 py-md-10">
      <Benefits
        :data="historyData"
        event-category="carrossel-nossa-historia"
        :event-index="0"
      />
    </highlight-container>
    <highlight-container title="Nosso guia">
      <v-row ma-0 pa-0 justify="center">
        <v-col v-for="(guide, i) in guides" :key="i" cols="12" sm="6" md="4">
          <goal :image="guide.image" class="pa-0 ma-0" height="350px">
            <template v-slot:title>
              <h4 class="text-center">
                {{ guide.title }}
              </h4>
            </template>
            <template v-slot:description>
              <p class="px-sm-4 text-center">
                {{ guide.content }}
              </p>
            </template>
          </goal>
        </v-col>
      </v-row>
    </highlight-container>
    <highlight-container
      even
      title="Uma iniciativa premiada globalmente"
      subtitle="Acreditamos na nossa solução como o futuro da reciclagem e ficamos felizes em ver nosso trabalho
                reconhecido globalmente por diversas iniciativas de impacto socioambiental."
    >
      <v-container fluid>
        <v-row justify="start">
          <v-col
            v-for="(reward, i) in rewards"
            :key="i"
            class="rewards mb-5"
            cols="6"
            sm="4"
            md="3"
          >
            <a
              :href="reward.link"
              target="blank"
              @click="
                $analytics('iniciativa-premiada', 'click', reward.eventLabel)
              "
            >
              <v-row align="center">
                <v-col
                  cols="12"
                  class="pa-1"
                  align="center"
                  style="height: 70px"
                >
                  <v-img
                    contain
                    :src="reward.image"
                    height="100%"
                    :max-width="reward.width"
                    class="mb-2"
                  />
                </v-col>
                <v-col cols="12" align="center">
                  <p class="px-0 px-sm-5">
                    {{ reward.description }}
                  </p>
                </v-col>
              </v-row>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </highlight-container>
    <highlight-container
      fluid
      title="Na mídia"
      subtitle="Grandes canais de comunicação reforçam a importância das pautas sobre resíduos sólidos e reciclagem no
                mundo e reconhecem a efetividade da solução eu<b>reciclo</b>."
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="(me, i) in medias"
            :key="i"
            class="medias"
            cols="6"
            sm="3"
            md="2"
          >
            <a
              :href="me.link"
              target="blank"
              @click="$analytics('na-mídia', 'click', me.eventLabel)"
            >
              <v-img
                contain
                height="100%"
                :max-width="me.width"
                :src="me.image"
              />
            </a>
          </v-col>
        </v-row>
      </v-container>
    </highlight-container>
  </div>
</template>

<script>
import reward10 from '@/assets/images/about/rewards/reward10.png';

export default {
  name: 'About',
  metaInfo: {
    title: 'Sobre',
  },
  components: {
    Goal: () => import('@/components/Goal.vue'),
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    Benefits: () => import('@/components/Benefits.vue'),
  },
  data() {
    return {
      historyData: [
        {
          text: `Em 2014, Thiago Pinto, estudante de MBA em Northwestern Kellogg School of Management, vê nos baixos
                índices de reciclagem e na marginalização dos atores da cadeia uma oportunidade de atuação. Apaixonados
                por transformar o mundo em um lugar mais sustentável, Thiago e Luciana Oliveira, co-fundadores da eu<b>reciclo</b>,
                trazem ao Brasil um projeto que viria a revolucionar a forma como administramos os resíduos sólidos.`,
          image: require('@/assets/images/about/history/slide1.jpg'),
        },
        {
          text: `Em 2015, com um time de 5 pessoas engajadas no mesmo propósito, é criada a New Hope Ecotech, trazendo
                a primeira tecnologia para rastreamento dos resíduos pós-consumo do Brasil. Um ano depois, essa tecnologia
                ganha forma através do selo eu<b>reciclo</b> e se consolida como uma solução que atende a necessidade das empresas
                para cumprimento da Logística Reversa de Embalagens.`,
          image: require('@/assets/images/about/history/slide2.jpg'),
        },
        {
          text: `Em maio de 2018, é assinado o Termo de Compromisso de Logística Reversa (TCLR) do estado de São Paulo,
                do qual a New Hope Ecotech (eu<b>reciclo</b>) é parte. Em novembro do mesmo ano, a eu<b>reciclo</b> promove, em conjunto
                com os outros atores do Sistema de Logística Reversa do Estado de São Paulo, a primeira de uma série de
                Concorrências de Certificados de Reciclagem.`,
          image: require('@/assets/images/about/history/slide3.jpg'),
        },
        {
          text: `Ao longo dos anos, a solução foi reconhecida em mais de 10 premiações e segue conquistando a adesão
                das empresas, dos consumidores e de outras entidades. Hoje, são mais de 6.700 marcas parceiras que perceberam
                que com o selo eu<b>reciclo</b> a Logística Reversa de Embalagens pode ser mais simples e transparente.`,
          image: require('@/assets/images/about/history/slide4.jpg'),
        },
      ],
      guides: [
        {
          title: 'Missão',
          image: require('@/assets/images/about/guides/missao.jpg'),
          content: 'Construir um mundo sustentável, valorizando a reciclagem.',
        },
        {
          title: 'Visão',
          image: require('@/assets/images/about/guides/visao.jpg'),
          content: 'Ultrapassar as metas de reciclagem na América Latina.',
        },
        {
          title: 'Valores',
          image: require('@/assets/images/about/guides/valores.jpg'),
          content:
            'Resolutivo, Apaixonado, Colaborativo, Inclusivo, Empreendedor e Confiável.',
        },
      ],
      rewards: [
        {
          link:
            'https://medium.com/@blackboxvc/google-for-entrepreneurs-and-blackbox-celebrate-10th-batch-of-global-startups-selected-for-silicon-c9a7a1b3642c',
          description: 'Blackbox Connect 20',
          image: require('@/assets/images/about/rewards/reward1.png'),
          width: 100,
          eventLabel: 'blackbox_connect',
        },
        {
          link:
            'http://www.startupchile.org/es/resultados-g18-seed-start-up-chile-invertira-clp2000m-en-100-nuevas-startups/',
          description: 'Startup Chile: the G18 Seed',
          image: require('@/assets/images/about/rewards/reward2.png'),
          width: 196,
          eventLabel: 'startup_chile',
        },
        {
          link: 'https://www.campus.co/sao-paulo/pt/campus-residency/',
          description:
            'Google for Startups Residency: Class #1 at Campus São Paulo',
          image: require('@/assets/images/about/rewards/reward3.png'),
          width: 196,
          eventLabel: 'google_startups',
        },
        {
          link: `https://thecirculars.org/our-finalists/filter/eyJyZXN1bHRfcGFnZSI6Im91ci1maW5hbGlzdHNcL2ZpbHRlciIsInNl
                YXJjaDpjc195ZWFyIjoiMjAxNiJ9`,
          description: 'The BT Award for Circular Economy Digital Disruptor',
          image: require('@/assets/images/about/rewards/reward4.png'),
          width: 100,
          eventLabel: 'the_bt_award',
        },
        {
          link: `https://thecirculars.org/our-finalists/filter/eyJyZXN1bHRfcGFnZSI6Im91ci1maW5hbGlzdHNcL2ZpbHRlciIsInNl
                YXJjaDpjc195ZWFyIjoiMjAxNiJ9`,
          description:
            'The Young Global Leaders Award for Circular Economy Entrepreneur',
          image: require('@/assets/images/about/rewards/reward5.png'),
          width: 100,
          eventLabel: 'young_global_leaders',
        },
        {
          link: 'https://espacioschmidheiny.net/es/',
          description:
            'Stephan Schmidheiny Innovation For Sustainability Awards',
          image: require('@/assets/images/about/rewards/reward6.png'),
          width: 100,
          eventLabel: 'stephan_schmidheiny_awards',
        },
        {
          link:
            'https://m.blogs.ne10.uol.com.br/mundobit/2015/11/19/conheca-os-brasileiros-mais-inovadores-com-menos-de-35-anos/',
          description: 'MIT EmTech Inovadores com Menos de 35 anos Brasil',
          image: require('@/assets/images/about/rewards/reward7.png'),
          width: 118,
          eventLabel: 'MIT_emtech',
        },
        {
          link: 'http://bbc.sasin.edu/',
          description: 'The mai Bangkok Business Challenge',
          image: require('@/assets/images/about/rewards/reward8.png'),
          width: 36,
          eventLabel: 'mai_bangkok_challenge',
        },
        {
          link:
            'https://www.unilever.com/sustainable-living/join-in/Young-Entrepreneur-Awards-2016/',
          description:
            'The Unilever Sustainable Living Youg Entrepreneur Awards 2015/2016',
          image: require('@/assets/images/about/rewards/reward9.png'),
          width: 140,
          eventLabel: 'unilever_sustainable_awards',
        },
        {
          link:
            'http://designtoimprovelife.dk/new-hope-ecotech-new-policy-connects-polluters-with-waste-collectors/',
          description: 'Design to Improve Life Award',
          image: reward10,
          width: 88,
          eventLabel: 'design_to_improve',
        },
        {
          link: 'http://www.kellogg.northwestern.edu/social-impact/career.aspx',
          description: 'Kellog Social Entreprise Award',
          image: require('@/assets/images/about/rewards/reward11.png'),
          width: 62,
          eventLabel: 'kellog_social_award',
        },
        {
          link: 'https://www.sistemabbrasil.org/best-of-the-world',
          description: 'Best For The World™ 2022 - Categoria Comunidade',
          image: require('@/assets/images/about/rewards/reward12.png'),
          width: 62,
          eventLabel: 'sistema_b_brasil_BFTW',
        },
        {
          link:
            'https://www.amcham.com.br/noticias/sustentabilidade/amcham-revela-os-ganhadores-do-premio-eco-2022-2',
          description:
            'Prêmio Eco 2021/2022 - Categoria Sustentabilidade em Produtos e Serviços',
          image: require('@/assets/images/about/rewards/reward13.png'),
          width: 62,
          eventLabel: 'premio_eco_2021_2022',
        },
      ],
      medias: [
        {
          link:
            'http://www.thehindubusinessline.com/cities4climate/startup-brings-technology-and-cooperatives-together-to-engage-companies-in-waste-management/article9299630.ece',
          image: require('@/assets/images/about/medias/media1.png'),
          width: 150,
          eventLabel: 'business_line',
        },
        {
          link:
            'http://elempresario.mx/emprendedores/new-hope-ecotech-empodera-recolectores-basura',
          image: require('@/assets/images/about/medias/media2.png'),
          width: 150,
          eventLabel: 'el_empresario',
        },
        {
          link:
            'http://conteudo.startse.com.br/empreendedores/juniorboneli/startup-brasileira-esta-entre-as-finalistas-do-maior-premio-de-design-do-mundo/',
          image: require('@/assets/images/about/medias/media3.png'),
          width: 150,
          eventLabel: 'start_se',
        },
        {
          link:
            'http://www.journal.lu/top-navigation/article/avec-la-technologie-contre-les-lixoes/?cHash=c303ad7103fd86af4d1d5fc99f28826f&L=0',
          image: require('@/assets/images/about/medias/media4.png'),
          width: 150,
          eventLabel: 'journal',
        },
        {
          link:
            'http://www.lesechos.fr/industrie-services/energie-environnement/0211459206566-bresil-le-big-data-au-secours-du-big-dechet-2040174.php',
          image: require('@/assets/images/about/medias/media5.png'),
          width: 150,
          eventLabel: 'les_echos',
        },
        {
          link:
            'http://www.valor.com.br/empresas/4764931/startup-reune-cooperativas-e-tecnologia-na-gestao-de-residuos',
          image: require('@/assets/images/about/medias/media6.png'),
          width: 150,
          eventLabel: 'valor_economico_1',
        },
        {
          link:
            'http://cincodias.com/cincodias/2016/11/04/empresas/1478262855_548890.html',
          image: require('@/assets/images/about/medias/media7.png'),
          width: 150,
          eventLabel: 'cinco_dias',
        },
        {
          link:
            'http://www.leconomiste.com/article/1004409-gestion-des-dechets',
          image: require('@/assets/images/about/medias/media8.png'),
          width: 150,
          eventLabel: 'leconomiste',
        },
        {
          link:
            'http://revistapegn.globo.com/Startups/noticia/2015/09/conheca-os-vencedores-do-slush-impact-brazil-2015.html',
          image: require('@/assets/images/about/medias/media9.png'),
          width: 150,
          eventLabel: 'pegn',
        },
        {
          link:
            'http://www.oestadoce.com.br/cadernos/oev/startup-brasileira-entre-as-finalistas-do-maior-premio-de-design-do-mundo',
          image: require('@/assets/images/about/medias/media10.png'),
          width: 150,
          eventLabel: 'o_estado',
        },
        {
          link:
            'http://www.administradores.com.br/noticias/empreendedorismo/startup-brasileira-esta-entre-as-finalistas-do-index-award/102133/',
          image: require('@/assets/images/about/medias/media11.png'),
          width: 130,
          eventLabel: 'administradores_com_br',
        },
        {
          link:
            'http://projetodraft.com/a-new-hope-ecotech-quer-organizar-a-bagunca-do-lixo/',
          image: require('@/assets/images/about/medias/media12.png'),
          width: 150,
          eventLabel: 'draft',
        },
        {
          link:
            'http://www.huffingtonpost.com/soren-petersen/the-index-award-and-why-i_b_7566766.html',
          image: require('@/assets/images/about/medias/media13.png'),
          width: 130,
          eventLabel: 'huffpost',
        },
        {
          link:
            'https://www.theguardian.com/sustainable-business/2016/jan/20/circular-economy-award-finalists-davos-airbnb-for-cars-canada-food-waste',
          image: require('@/assets/images/about/medias/media14.png'),
          width: 150,
          eventLabel: 'the_guardian',
        },
        {
          link:
            'http://www.valor.com.br/brasil/4362806/mit-premia-dez-projetos-brasileiros',
          image: require('@/assets/images/about/medias/media15.png'),
          width: 150,
          eventLabel: 'valor_economico_2',
        },
        {
          link:
            'https://revistagalileu.globo.com/Publicidade/inovaBra-habitat/noticia/2018/11/startup-garante-responsabilidade-das-empresas-com-processo-de-reciclagem.html',
          image: require('@/assets/images/about/medias/media16.png'),
          width: 150,
          eventLabel: 'galileu',
        },
        {
          link:
            'https://odia.ig.com.br/colunas/vida-e-meio-ambiente/2019/02/5619415-eureciclo--o-selo-que-faz-toda-a-diferenca.html#foto=1',
          image: require('@/assets/images/about/medias/media17.png'),
          width: 150,
          eventLabel: 'o_dia',
        },
        {
          link:
            'http://www.ciesp.com.br/noticias/2a-concorrencia-de-certificados-de-reciclagem-do-sistema-de-logistica-reversa-de-embalagens-foi-um-sucesso/',
          image: require('@/assets/images/about/medias/media18.png'),
          width: 150,
          eventLabel: 'ciesp',
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import "@/styles/style"

.goal
  margin: 0
  background-color: white

  h1, h2, h3, h4
    font-size: 1.5em
    color: white
    @media screen and (max-width: $sm)
      font-size: 1.3em
      line-height: 1.1em
    @media screen and (max-width: $xs)
      font-size: 1.1em
      line-height: 1.1em
.wrap-container
  padding: 0 10% 0 10%

.medias
  div
    background-color: transparent
    transition: all .2s ease-in-out
    margin: 0 auto
    display: flex
    align-items: center
    justify-content: center
    width: 220px
    height: 220px
    @media screen and (max-width: $md)
      width: 200px
      height: 200px
    @media screen and (max-width: $sm)
      width: 150px
      height: 150px
    @media screen and (max-width: $xs)
      width: 150px
      height: 170px
    img
      height: auto
      max-width: 100%
      padding: 10px
    &:hover
      transform: scale(1.025)
    a
      color: white
      text-decoration: none

.rewards
  height: 140px
  a
    text-decoration: none
    p
      font-size: 12px !important
      color: #57585b
      line-height: 1.25
      font-style: italic
      font: 16px/1.25 "Gotham Rounded", sans-serif

.new-color
  .rewards
    a
      p
        font: 16px/1.25 "metropolisregular", sans-serif
</style>
